<section class="reservations-page">
  <header class="top-strip">
    <img src="assets/dashboard/logoApp.svg" alt="AutoInsight logo" class="brand-logo" />
  </header>

  <main class="reservations-panel">
    <div class="panel-head">
      <button type="button" class="logout-btn" (click)="logout()">Log Out</button>
      <h1>Maintenance Reservations</h1>
    </div>

    <p class="subhead" *ngIf="mechanicName">Mechanic: {{ mechanicName }}</p>

    <p class="empty" *ngIf="loading">Loading reservations...</p>
    <p class="empty error" *ngIf="!loading && errorMessage">{{ errorMessage }}</p>

    <table class="reservations-table" *ngIf="!loading && !errorMessage && reservations.length > 0; else emptyState">
      <thead>
        <tr>
          <th>Part</th>
          <th>Owner</th>
          <th>Vehicle</th>
          <th>Date</th>
          <th>Time</th>
          <th>Status</th>
          <th>Vehicle Profile</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of reservations">
          <td>{{ item.partName }}</td>
          <td>{{ item.ownerId }}</td>
          <td>{{ item.vehicleId ?? '-' }}</td>
          <td>{{ item.date }}</td>
          <td>{{ item.fromTime }} - {{ item.toTime }}</td>
          <td>{{ item.status }}</td>
          <td>
            <button type="button" class="parts-link" (click)="openMaintenanceParts(item)">maintParts</button>
          </td>
          <td class="actions">
            <button
              type="button"
              class="approve-btn"
              (click)="approve(item)"
              [disabled]="item.status !== 'Pending Approval' || processingReservationId === item.id">
              Approve
            </button>
            <button
              type="button"
              class="deny-btn"
              (click)="deny(item)"
              [disabled]="item.status !== 'Pending Approval' || processingReservationId === item.id">
              Deny
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <ng-template #emptyState>
      <p class="empty" *ngIf="!loading && !errorMessage">No maintenance reservations found.</p>
    </ng-template>
  </main>
</section>
